import { OrganizationSchema, UserSchema } from '../definitions/schemas';
import OrganizationsStore from '../stores/observables/OrganizationsStore';

/**
 * @see https://gitlab.com/mindtickle/mt-shell/-/blob/track/integration/packages/ui-shell/src/components/Zipy/hooks/useZipy.ts#L17-19
 */
const COMPANY_TAGS = {
  ID: 'cname',
  LEARNING_SITE: 'Learning Site',
};

const MAX_RETRIES = 5;

let retries = 1;
let isZipyInitialized = false;

const buildCompanyContext = (organization: OrganizationSchema) => {
  const { id, vendor, vendorTenantId, vendorTenantUrl } = organization;

  let orgId = vendor?.analyticsPrefix ? `${vendor.analyticsPrefix}-${id}` : id;
  let learningSite = window.location.hostname;

  if (vendorTenantId && vendorTenantUrl) {
    const url = new URL(vendorTenantUrl);
    orgId = vendorTenantId;
    learningSite = url.hostname;
  }

  return {
    [COMPANY_TAGS.ID]: orgId,
    [COMPANY_TAGS.LEARNING_SITE]: learningSite,
  };
};

const identify = (
  userId: string,
  user: UserSchema,
  forcedOrg?: OrganizationSchema
) => {
  if (isZipyInitialized || retries > MAX_RETRIES) {
    return;
  }

  const organization = forcedOrg || OrganizationsStore.getCurrentOrganization();
  if (!(window.zipy && organization)) {
    setTimeout(() => identify(userId, user, forcedOrg), retries * 1000);
    retries++;
    return;
  }

  isZipyInitialized = true;

  const zipyData = { ...buildCompanyContext(organization), email: user.email };
  window.zipy.identify(user.id, zipyData);

  console.info(`Zipy identify user ${userId}`, zipyData);
};

export default {
  identify,
};
